// src/components/BlockedScreen.jsx
//
// Полноэкранный экран блокировки. Показывается когда:
//   - Бэк вернул 403 { error: 'blocked', kind, reason }
//   - В AuthProvider установлен blockedInfo
//
// Пользователь видит понятное сообщение с причиной, кнопку «Связаться»
// (телеграм / WhatsApp админа) и кнопку «Выйти» которая закрывает экран
// и возвращает на стартовый PreAuthFlow.

import { useTranslation } from 'react-i18next';
import { useSupport } from '../hooks/useSupport';
import { useAuth } from '../hooks/useAuth';
import Icon from './Icon';

// Контакты приходят С СЕРВЕРА (hooks/useSupport). Значения ниже — только
// запасные, на случай, если бэкенд недоступен: лучше показать старый контакт,
// чем не показать никакого. Заблокированному пользователю связь нужна как раз тогда,
// когда что-то не работает.

export default function BlockedScreen() {
  const { t } = useTranslation();
  const { blockedInfo, clearBlocked } = useAuth();
  const { contacts } = useSupport();

  if (!blockedInfo) return null;

  const kind = blockedInfo.kind || 'user';   // 'user' | 'shop'
  const reason = blockedInfo.reason;

  const title = kind === 'shop'
    ? t('blocked.titleShop')
    : t('blocked.titleUser');

  const subtitle = kind === 'shop'
    ? t('blocked.subtitleShop')
    : t('blocked.subtitleUser');

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 24,
      background: 'var(--bg, #0f1216)',
      color: 'var(--fg, #fff)',
      textAlign: 'center',
    }}>
      <div style={{
        width: 80, height: 80,
        borderRadius: '50%',
        background: 'var(--danger-soft, #3a1c1c)',
        color: 'var(--danger, #ff4d4f)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 24,
      }}>
        <Icon name="lock" size={40} />
      </div>

      <h1 style={{
        fontSize: 24,
        fontWeight: 800,
        margin: '0 0 12px',
        letterSpacing: '-0.02em',
      }}>
        {title}
      </h1>

      <p style={{
        fontSize: 15,
        color: 'var(--fg-muted, #9ca3af)',
        margin: '0 0 24px',
        maxWidth: 320,
        lineHeight: 1.5,
      }}>
        {subtitle}
      </p>

      {reason && (
        <div style={{
          background: 'var(--surface-2, #1a1f26)',
          border: '1px solid var(--border, #2a2f36)',
          borderRadius: 12,
          padding: 16,
          marginBottom: 24,
          maxWidth: 320,
          width: '100%',
        }}>
          <div style={{
            fontSize: 12,
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            color: 'var(--fg-muted, #9ca3af)',
            marginBottom: 6,
          }}>
            {t('blocked.reasonLabel')}
          </div>
          <div style={{ fontSize: 14, lineHeight: 1.4 }}>
            {reason}
          </div>
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, width: '100%', maxWidth: 320 }}>
        <a
          href={contacts.telegram}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-primary btn-lg"
          style={{ textDecoration: 'none', textAlign: 'center' }}
        >
          {t('blocked.contactTelegram')}
        </a>
        <a
          href={contacts.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-lg"
          style={{ textDecoration: 'none', textAlign: 'center' }}
        >
          {t('blocked.contactWhatsapp')}
        </a>
        <button
          className="btn btn-ghost btn-lg"
          onClick={clearBlocked}
        >
          {t('blocked.exitButton')}
        </button>
      </div>
    </div>
  );
}
